import { useCallback, useState } from 'react';

export default ({
  me,
  issueBill,
  onMenuClick,
  record,
  updateTransactionRows,
  onClose
}) => {
  const [failedLineItems, setFailedLineItems] = useState([]);
  const handleIssueSyncClick = useCallback(async () => {
    const result = await issueBill(true);

    if (result.issueBill.success) {
      onClose();
      updateTransactionRows && updateTransactionRows();

      return;
    }
    setFailedLineItems(result.issueBill.failedLineItems);
  }, [issueBill, onClose, updateTransactionRows]);

  const handleIssueEmailClick = useCallback(async () => {
    const result = await issueBill(false);

    if (result.issueBill.success) {
      onClose();
      onMenuClick();
    } else setFailedLineItems(result.issueBill.failedLineItems);
  }, [issueBill, onClose, onMenuClick]);

  const handleIssuePrintClick = useCallback(async () => {
    const result = await issueBill(false);

    if (result.issueBill.success) {
      onClose();
      updateTransactionRows && updateTransactionRows();
      window.open(
        `${me.uiRootPath}invoicing2/invoice-snapshot/${record.id}`,
        '_blank'
      );

      return;
    }
    setFailedLineItems(result.issueBill.failedLineItems);
  }, [issueBill, me.uiRootPath, onClose, record.id, updateTransactionRows]);

  return {
    failedLineItems,
    setFailedLineItems,
    handleIssuePrintClick,
    handleIssueEmailClick,
    handleIssueSyncClick
  };
};
